import * as ee from "react";
import Br, { forwardRef as Gr, useContext as Nt, Children as $t, Fragment as kt } from "react";
import { Divider as It } from "@illa-design/divider";
import { css as U } from "@emotion/react";
import { applyBoxStyle as Dt, deleteCssProps as Mt } from "@illa-design/theme";
var ir = { exports: {} }, Ee = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Nr;
function Ft() {
  if (Nr)
    return Ee;
  Nr = 1;
  var e = Br, r = Symbol.for("react.element"), n = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function u(l, p, h) {
    var d, y = {}, $ = null, k = null;
    h !== void 0 && ($ = "" + h), p.key !== void 0 && ($ = "" + p.key), p.ref !== void 0 && (k = p.ref);
    for (d in p)
      a.call(p, d) && !i.hasOwnProperty(d) && (y[d] = p[d]);
    if (l && l.defaultProps)
      for (d in p = l.defaultProps, p)
        y[d] === void 0 && (y[d] = p[d]);
    return { $$typeof: r, type: l, key: $, ref: k, props: y, _owner: o.current };
  }
  return Ee.Fragment = n, Ee.jsx = u, Ee.jsxs = u, Ee;
}
var ge = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $r;
function jt() {
  return $r || ($r = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Br, r = Symbol.for("react.element"), n = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), u = Symbol.for("react.provider"), l = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), h = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), $ = Symbol.for("react.lazy"), k = Symbol.for("react.offscreen"), A = Symbol.iterator, b = "@@iterator";
    function M(t) {
      if (t === null || typeof t != "object")
        return null;
      var s = A && t[A] || t[b];
      return typeof s == "function" ? s : null;
    }
    var S = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function E(t) {
      {
        for (var s = arguments.length, f = new Array(s > 1 ? s - 1 : 0), m = 1; m < s; m++)
          f[m - 1] = arguments[m];
        P("error", t, f);
      }
    }
    function P(t, s, f) {
      {
        var m = S.ReactDebugCurrentFrame, x = m.getStackAddendum();
        x !== "" && (s += "%s", f = f.concat([x]));
        var N = f.map(function(_) {
          return String(_);
        });
        N.unshift("Warning: " + s), Function.prototype.apply.call(console[t], console, N);
      }
    }
    var I = !1, c = !1, V = !1, O = !1, Ge = !1, we;
    we = Symbol.for("react.module.reference");
    function Je(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === a || t === i || Ge || t === o || t === h || t === d || O || t === k || I || c || V || typeof t == "object" && t !== null && (t.$$typeof === $ || t.$$typeof === y || t.$$typeof === u || t.$$typeof === l || t.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === we || t.getModuleId !== void 0));
    }
    function Ke(t, s, f) {
      var m = t.displayName;
      if (m)
        return m;
      var x = s.displayName || s.name || "";
      return x !== "" ? f + "(" + x + ")" : f;
    }
    function Ce(t) {
      return t.displayName || "Context";
    }
    function G(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && E("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case a:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case h:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var s = t;
            return Ce(s) + ".Consumer";
          case u:
            var f = t;
            return Ce(f._context) + ".Provider";
          case p:
            return Ke(t, t.render, "ForwardRef");
          case y:
            var m = t.displayName || null;
            return m !== null ? m : G(t.type) || "Memo";
          case $: {
            var x = t, N = x._payload, _ = x._init;
            try {
              return G(_(N));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var X = Object.assign, re = 0, Te, Oe, le, Pe, de, Ae, Ne;
    function $e() {
    }
    $e.__reactDisabledLog = !0;
    function He() {
      {
        if (re === 0) {
          Te = console.log, Oe = console.info, le = console.warn, Pe = console.error, de = console.group, Ae = console.groupCollapsed, Ne = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: $e,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        re++;
      }
    }
    function Ze() {
      {
        if (re--, re === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: X({}, t, {
              value: Te
            }),
            info: X({}, t, {
              value: Oe
            }),
            warn: X({}, t, {
              value: le
            }),
            error: X({}, t, {
              value: Pe
            }),
            group: X({}, t, {
              value: de
            }),
            groupCollapsed: X({}, t, {
              value: Ae
            }),
            groupEnd: X({}, t, {
              value: Ne
            })
          });
        }
        re < 0 && E("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var pe = S.ReactCurrentDispatcher, ve;
    function ne(t, s, f) {
      {
        if (ve === void 0)
          try {
            throw Error();
          } catch (x) {
            var m = x.stack.trim().match(/\n( *(at )?)/);
            ve = m && m[1] || "";
          }
        return `
` + ve + t;
      }
    }
    var he = !1, ae;
    {
      var Xe = typeof WeakMap == "function" ? WeakMap : Map;
      ae = new Xe();
    }
    function v(t, s) {
      if (!t || he)
        return "";
      {
        var f = ae.get(t);
        if (f !== void 0)
          return f;
      }
      var m;
      he = !0;
      var x = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var N;
      N = pe.current, pe.current = null, He();
      try {
        if (s) {
          var _ = function() {
            throw Error();
          };
          if (Object.defineProperty(_.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(_, []);
            } catch (Q) {
              m = Q;
            }
            Reflect.construct(t, [], _);
          } else {
            try {
              _.call();
            } catch (Q) {
              m = Q;
            }
            t.call(_.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Q) {
            m = Q;
          }
          t();
        }
      } catch (Q) {
        if (Q && m && typeof Q.stack == "string") {
          for (var g = Q.stack.split(`
`), W = m.stack.split(`
`), D = g.length - 1, F = W.length - 1; D >= 1 && F >= 0 && g[D] !== W[F]; )
            F--;
          for (; D >= 1 && F >= 0; D--, F--)
            if (g[D] !== W[F]) {
              if (D !== 1 || F !== 1)
                do
                  if (D--, F--, F < 0 || g[D] !== W[F]) {
                    var B = `
` + g[D].replace(" at new ", " at ");
                    return t.displayName && B.includes("<anonymous>") && (B = B.replace("<anonymous>", t.displayName)), typeof t == "function" && ae.set(t, B), B;
                  }
                while (D >= 1 && F >= 0);
              break;
            }
        }
      } finally {
        he = !1, pe.current = N, Ze(), Error.prepareStackTrace = x;
      }
      var se = t ? t.displayName || t.name : "", Ar = se ? ne(se) : "";
      return typeof t == "function" && ae.set(t, Ar), Ar;
    }
    function me(t, s, f) {
      return v(t, !1);
    }
    function oe(t) {
      var s = t.prototype;
      return !!(s && s.isReactComponent);
    }
    function te(t, s, f) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return v(t, oe(t));
      if (typeof t == "string")
        return ne(t);
      switch (t) {
        case h:
          return ne("Suspense");
        case d:
          return ne("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case p:
            return me(t.render);
          case y:
            return te(t.type, s, f);
          case $: {
            var m = t, x = m._payload, N = m._init;
            try {
              return te(N(x), s, f);
            } catch {
            }
          }
        }
      return "";
    }
    var ke = Object.prototype.hasOwnProperty, Er = {}, gr = S.ReactDebugCurrentFrame;
    function Ie(t) {
      if (t) {
        var s = t._owner, f = te(t.type, t._source, s ? s.type : null);
        gr.setExtraStackFrame(f);
      } else
        gr.setExtraStackFrame(null);
    }
    function lt(t, s, f, m, x) {
      {
        var N = Function.call.bind(ke);
        for (var _ in t)
          if (N(t, _)) {
            var g = void 0;
            try {
              if (typeof t[_] != "function") {
                var W = Error((m || "React class") + ": " + f + " type `" + _ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[_] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw W.name = "Invariant Violation", W;
              }
              g = t[_](s, _, m, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (D) {
              g = D;
            }
            g && !(g instanceof Error) && (Ie(x), E("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", m || "React class", f, _, typeof g), Ie(null)), g instanceof Error && !(g.message in Er) && (Er[g.message] = !0, Ie(x), E("Failed %s type: %s", f, g.message), Ie(null));
          }
      }
    }
    var dt = Array.isArray;
    function Qe(t) {
      return dt(t);
    }
    function pt(t) {
      {
        var s = typeof Symbol == "function" && Symbol.toStringTag, f = s && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return f;
      }
    }
    function vt(t) {
      try {
        return br(t), !1;
      } catch {
        return !0;
      }
    }
    function br(t) {
      return "" + t;
    }
    function _r(t) {
      if (vt(t))
        return E("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", pt(t)), br(t);
    }
    var ye = S.ReactCurrentOwner, ht = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Sr, xr, er;
    er = {};
    function mt(t) {
      if (ke.call(t, "ref")) {
        var s = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function yt(t) {
      if (ke.call(t, "key")) {
        var s = Object.getOwnPropertyDescriptor(t, "key").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function Et(t, s) {
      if (typeof t.ref == "string" && ye.current && s && ye.current.stateNode !== s) {
        var f = G(ye.current.type);
        er[f] || (E('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', G(ye.current.type), t.ref), er[f] = !0);
      }
    }
    function gt(t, s) {
      {
        var f = function() {
          Sr || (Sr = !0, E("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        f.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: f,
          configurable: !0
        });
      }
    }
    function bt(t, s) {
      {
        var f = function() {
          xr || (xr = !0, E("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        f.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: f,
          configurable: !0
        });
      }
    }
    var _t = function(t, s, f, m, x, N, _) {
      var g = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: t,
        key: s,
        ref: f,
        props: _,
        // Record the component responsible for creating this element.
        _owner: N
      };
      return g._store = {}, Object.defineProperty(g._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(g, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: m
      }), Object.defineProperty(g, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: x
      }), Object.freeze && (Object.freeze(g.props), Object.freeze(g)), g;
    };
    function St(t, s, f, m, x) {
      {
        var N, _ = {}, g = null, W = null;
        f !== void 0 && (_r(f), g = "" + f), yt(s) && (_r(s.key), g = "" + s.key), mt(s) && (W = s.ref, Et(s, x));
        for (N in s)
          ke.call(s, N) && !ht.hasOwnProperty(N) && (_[N] = s[N]);
        if (t && t.defaultProps) {
          var D = t.defaultProps;
          for (N in D)
            _[N] === void 0 && (_[N] = D[N]);
        }
        if (g || W) {
          var F = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          g && gt(_, F), W && bt(_, F);
        }
        return _t(t, g, W, x, m, ye.current, _);
      }
    }
    var rr = S.ReactCurrentOwner, Rr = S.ReactDebugCurrentFrame;
    function ie(t) {
      if (t) {
        var s = t._owner, f = te(t.type, t._source, s ? s.type : null);
        Rr.setExtraStackFrame(f);
      } else
        Rr.setExtraStackFrame(null);
    }
    var tr;
    tr = !1;
    function nr(t) {
      return typeof t == "object" && t !== null && t.$$typeof === r;
    }
    function wr() {
      {
        if (rr.current) {
          var t = G(rr.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function xt(t) {
      {
        if (t !== void 0) {
          var s = t.fileName.replace(/^.*[\\\/]/, ""), f = t.lineNumber;
          return `

Check your code at ` + s + ":" + f + ".";
        }
        return "";
      }
    }
    var Cr = {};
    function Rt(t) {
      {
        var s = wr();
        if (!s) {
          var f = typeof t == "string" ? t : t.displayName || t.name;
          f && (s = `

Check the top-level render call using <` + f + ">.");
        }
        return s;
      }
    }
    function Tr(t, s) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var f = Rt(s);
        if (Cr[f])
          return;
        Cr[f] = !0;
        var m = "";
        t && t._owner && t._owner !== rr.current && (m = " It was passed a child from " + G(t._owner.type) + "."), ie(t), E('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', f, m), ie(null);
      }
    }
    function Or(t, s) {
      {
        if (typeof t != "object")
          return;
        if (Qe(t))
          for (var f = 0; f < t.length; f++) {
            var m = t[f];
            nr(m) && Tr(m, s);
          }
        else if (nr(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var x = M(t);
          if (typeof x == "function" && x !== t.entries)
            for (var N = x.call(t), _; !(_ = N.next()).done; )
              nr(_.value) && Tr(_.value, s);
        }
      }
    }
    function wt(t) {
      {
        var s = t.type;
        if (s == null || typeof s == "string")
          return;
        var f;
        if (typeof s == "function")
          f = s.propTypes;
        else if (typeof s == "object" && (s.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        s.$$typeof === y))
          f = s.propTypes;
        else
          return;
        if (f) {
          var m = G(s);
          lt(f, t.props, "prop", m, t);
        } else if (s.PropTypes !== void 0 && !tr) {
          tr = !0;
          var x = G(s);
          E("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", x || "Unknown");
        }
        typeof s.getDefaultProps == "function" && !s.getDefaultProps.isReactClassApproved && E("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ct(t) {
      {
        for (var s = Object.keys(t.props), f = 0; f < s.length; f++) {
          var m = s[f];
          if (m !== "children" && m !== "key") {
            ie(t), E("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", m), ie(null);
            break;
          }
        }
        t.ref !== null && (ie(t), E("Invalid attribute `ref` supplied to `React.Fragment`."), ie(null));
      }
    }
    function Pr(t, s, f, m, x, N) {
      {
        var _ = Je(t);
        if (!_) {
          var g = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (g += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var W = xt(x);
          W ? g += W : g += wr();
          var D;
          t === null ? D = "null" : Qe(t) ? D = "array" : t !== void 0 && t.$$typeof === r ? (D = "<" + (G(t.type) || "Unknown") + " />", g = " Did you accidentally export a JSX literal instead of a component?") : D = typeof t, E("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", D, g);
        }
        var F = St(t, s, f, x, N);
        if (F == null)
          return F;
        if (_) {
          var B = s.children;
          if (B !== void 0)
            if (m)
              if (Qe(B)) {
                for (var se = 0; se < B.length; se++)
                  Or(B[se], t);
                Object.freeze && Object.freeze(B);
              } else
                E("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Or(B, t);
        }
        return t === a ? Ct(F) : wt(F), F;
      }
    }
    function Tt(t, s, f) {
      return Pr(t, s, f, !0);
    }
    function Ot(t, s, f) {
      return Pr(t, s, f, !1);
    }
    var Pt = Ot, At = Tt;
    ge.Fragment = a, ge.jsx = Pt, ge.jsxs = At;
  }()), ge;
}
process.env.NODE_ENV === "production" ? ir.exports = Ft() : ir.exports = jt();
var Ye = ir.exports;
function Vt(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function Yt(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var Lt = /* @__PURE__ */ function() {
  function e(n) {
    var a = this;
    this._insertTag = function(o) {
      var i;
      a.tags.length === 0 ? a.insertionPoint ? i = a.insertionPoint.nextSibling : a.prepend ? i = a.container.firstChild : i = a.before : i = a.tags[a.tags.length - 1].nextSibling, a.container.insertBefore(o, i), a.tags.push(o);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(a) {
    a.forEach(this._insertTag);
  }, r.insert = function(a) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Yt(this));
    var o = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var i = a.charCodeAt(0) === 64 && a.charCodeAt(1) === 105;
      i && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + a + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !i;
    }
    if (this.isSpeedy) {
      var u = Vt(o);
      try {
        u.insertRule(a, u.cssRules.length);
      } catch (l) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(a) && console.error('There was a problem inserting the following rule: "' + a + '"', l);
      }
    } else
      o.appendChild(document.createTextNode(a));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(a) {
      return a.parentNode && a.parentNode.removeChild(a);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), L = "-ms-", Le = "-moz-", R = "-webkit-", dr = "comm", pr = "rule", vr = "decl", Wt = "@import", Jr = "@keyframes", Ut = "@layer", zt = Math.abs, Ue = String.fromCharCode, qt = Object.assign;
function Bt(e, r) {
  return Y(e, 0) ^ 45 ? (((r << 2 ^ Y(e, 0)) << 2 ^ Y(e, 1)) << 2 ^ Y(e, 2)) << 2 ^ Y(e, 3) : 0;
}
function Kr(e) {
  return e.trim();
}
function Gt(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function w(e, r, n) {
  return e.replace(r, n);
}
function sr(e, r) {
  return e.indexOf(r);
}
function Y(e, r) {
  return e.charCodeAt(r) | 0;
}
function _e(e, r, n) {
  return e.slice(r, n);
}
function K(e) {
  return e.length;
}
function hr(e) {
  return e.length;
}
function De(e, r) {
  return r.push(e), e;
}
function Jt(e, r) {
  return e.map(r).join("");
}
var ze = 1, fe = 1, Hr = 0, z = 0, j = 0, ue = "";
function qe(e, r, n, a, o, i, u) {
  return { value: e, root: r, parent: n, type: a, props: o, children: i, line: ze, column: fe, length: u, return: "" };
}
function be(e, r) {
  return qt(qe("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function Kt() {
  return j;
}
function Ht() {
  return j = z > 0 ? Y(ue, --z) : 0, fe--, j === 10 && (fe = 1, ze--), j;
}
function q() {
  return j = z < Hr ? Y(ue, z++) : 0, fe++, j === 10 && (fe = 1, ze++), j;
}
function Z() {
  return Y(ue, z);
}
function Fe() {
  return z;
}
function Re(e, r) {
  return _e(ue, e, r);
}
function Se(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Zr(e) {
  return ze = fe = 1, Hr = K(ue = e), z = 0, [];
}
function Xr(e) {
  return ue = "", e;
}
function je(e) {
  return Kr(Re(z - 1, cr(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Zt(e) {
  for (; (j = Z()) && j < 33; )
    q();
  return Se(e) > 2 || Se(j) > 3 ? "" : " ";
}
function Xt(e, r) {
  for (; --r && q() && !(j < 48 || j > 102 || j > 57 && j < 65 || j > 70 && j < 97); )
    ;
  return Re(e, Fe() + (r < 6 && Z() == 32 && q() == 32));
}
function cr(e) {
  for (; q(); )
    switch (j) {
      case e:
        return z;
      case 34:
      case 39:
        e !== 34 && e !== 39 && cr(j);
        break;
      case 40:
        e === 41 && cr(e);
        break;
      case 92:
        q();
        break;
    }
  return z;
}
function Qt(e, r) {
  for (; q() && e + j !== 47 + 10; )
    if (e + j === 42 + 42 && Z() === 47)
      break;
  return "/*" + Re(r, z - 1) + "*" + Ue(e === 47 ? e : q());
}
function en(e) {
  for (; !Se(Z()); )
    q();
  return Re(e, z);
}
function rn(e) {
  return Xr(Ve("", null, null, null, [""], e = Zr(e), 0, [0], e));
}
function Ve(e, r, n, a, o, i, u, l, p) {
  for (var h = 0, d = 0, y = u, $ = 0, k = 0, A = 0, b = 1, M = 1, S = 1, E = 0, P = "", I = o, c = i, V = a, O = P; M; )
    switch (A = E, E = q()) {
      case 40:
        if (A != 108 && Y(O, y - 1) == 58) {
          sr(O += w(je(E), "&", "&\f"), "&\f") != -1 && (S = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        O += je(E);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        O += Zt(A);
        break;
      case 92:
        O += Xt(Fe() - 1, 7);
        continue;
      case 47:
        switch (Z()) {
          case 42:
          case 47:
            De(tn(Qt(q(), Fe()), r, n), p);
            break;
          default:
            O += "/";
        }
        break;
      case 123 * b:
        l[h++] = K(O) * S;
      case 125 * b:
      case 59:
      case 0:
        switch (E) {
          case 0:
          case 125:
            M = 0;
          case 59 + d:
            S == -1 && (O = w(O, /\f/g, "")), k > 0 && K(O) - y && De(k > 32 ? Ir(O + ";", a, n, y - 1) : Ir(w(O, " ", "") + ";", a, n, y - 2), p);
            break;
          case 59:
            O += ";";
          default:
            if (De(V = kr(O, r, n, h, d, o, l, P, I = [], c = [], y), i), E === 123)
              if (d === 0)
                Ve(O, r, V, V, I, i, y, l, c);
              else
                switch ($ === 99 && Y(O, 3) === 110 ? 100 : $) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Ve(e, V, V, a && De(kr(e, V, V, 0, 0, o, l, P, o, I = [], y), c), o, c, y, l, a ? I : c);
                    break;
                  default:
                    Ve(O, V, V, V, [""], c, 0, l, c);
                }
        }
        h = d = k = 0, b = S = 1, P = O = "", y = u;
        break;
      case 58:
        y = 1 + K(O), k = A;
      default:
        if (b < 1) {
          if (E == 123)
            --b;
          else if (E == 125 && b++ == 0 && Ht() == 125)
            continue;
        }
        switch (O += Ue(E), E * b) {
          case 38:
            S = d > 0 ? 1 : (O += "\f", -1);
            break;
          case 44:
            l[h++] = (K(O) - 1) * S, S = 1;
            break;
          case 64:
            Z() === 45 && (O += je(q())), $ = Z(), d = y = K(P = O += en(Fe())), E++;
            break;
          case 45:
            A === 45 && K(O) == 2 && (b = 0);
        }
    }
  return i;
}
function kr(e, r, n, a, o, i, u, l, p, h, d) {
  for (var y = o - 1, $ = o === 0 ? i : [""], k = hr($), A = 0, b = 0, M = 0; A < a; ++A)
    for (var S = 0, E = _e(e, y + 1, y = zt(b = u[A])), P = e; S < k; ++S)
      (P = Kr(b > 0 ? $[S] + " " + E : w(E, /&\f/g, $[S]))) && (p[M++] = P);
  return qe(e, r, n, o === 0 ? pr : l, p, h, d);
}
function tn(e, r, n) {
  return qe(e, r, n, dr, Ue(Kt()), _e(e, 2, -2), 0);
}
function Ir(e, r, n, a) {
  return qe(e, r, n, vr, _e(e, 0, a), _e(e, a + 1, -1), a);
}
function ce(e, r) {
  for (var n = "", a = hr(e), o = 0; o < a; o++)
    n += r(e[o], o, e, r) || "";
  return n;
}
function nn(e, r, n, a) {
  switch (e.type) {
    case Ut:
      if (e.children.length)
        break;
    case Wt:
    case vr:
      return e.return = e.return || e.value;
    case dr:
      return "";
    case Jr:
      return e.return = e.value + "{" + ce(e.children, a) + "}";
    case pr:
      e.value = e.props.join(",");
  }
  return K(n = ce(e.children, a)) ? e.return = e.value + "{" + n + "}" : "";
}
function an(e) {
  var r = hr(e);
  return function(n, a, o, i) {
    for (var u = "", l = 0; l < r; l++)
      u += e[l](n, a, o, i) || "";
    return u;
  };
}
function on(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function sn(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return r[n] === void 0 && (r[n] = e(n)), r[n];
  };
}
var cn = function(r, n, a) {
  for (var o = 0, i = 0; o = i, i = Z(), o === 38 && i === 12 && (n[a] = 1), !Se(i); )
    q();
  return Re(r, z);
}, fn = function(r, n) {
  var a = -1, o = 44;
  do
    switch (Se(o)) {
      case 0:
        o === 38 && Z() === 12 && (n[a] = 1), r[a] += cn(z - 1, n, a);
        break;
      case 2:
        r[a] += je(o);
        break;
      case 4:
        if (o === 44) {
          r[++a] = Z() === 58 ? "&\f" : "", n[a] = r[a].length;
          break;
        }
      default:
        r[a] += Ue(o);
    }
  while (o = q());
  return r;
}, un = function(r, n) {
  return Xr(fn(Zr(r), n));
}, Dr = /* @__PURE__ */ new WeakMap(), ln = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var n = r.value, a = r.parent, o = r.column === a.column && r.line === a.line; a.type !== "rule"; )
      if (a = a.parent, !a)
        return;
    if (!(r.props.length === 1 && n.charCodeAt(0) !== 58 && !Dr.get(a)) && !o) {
      Dr.set(r, !0);
      for (var i = [], u = un(n, i), l = a.props, p = 0, h = 0; p < u.length; p++)
        for (var d = 0; d < l.length; d++, h++)
          r.props[h] = i[p] ? u[p].replace(/&\f/g, l[d]) : l[d] + " " + u[p];
    }
  }
}, dn = function(r) {
  if (r.type === "decl") {
    var n = r.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, pn = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", vn = function(r) {
  return r.type === "comm" && r.children.indexOf(pn) > -1;
}, hn = function(r) {
  return function(n, a, o) {
    if (!(n.type !== "rule" || r.compat)) {
      var i = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (i) {
        for (var u = !!n.parent, l = u ? n.parent.children : (
          // global rule at the root level
          o
        ), p = l.length - 1; p >= 0; p--) {
          var h = l[p];
          if (h.line < n.line)
            break;
          if (h.column < n.column) {
            if (vn(h))
              return;
            break;
          }
        }
        i.forEach(function(d) {
          console.error('The pseudo class "' + d + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + d.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, Qr = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, mn = function(r, n) {
  for (var a = r - 1; a >= 0; a--)
    if (!Qr(n[a]))
      return !0;
  return !1;
}, Mr = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, yn = function(r, n, a) {
  Qr(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), Mr(r)) : mn(n, a) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), Mr(r)));
};
function et(e, r) {
  switch (Bt(e, r)) {
    case 5103:
      return R + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return R + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return R + e + Le + e + L + e + e;
    case 6828:
    case 4268:
      return R + e + L + e + e;
    case 6165:
      return R + e + L + "flex-" + e + e;
    case 5187:
      return R + e + w(e, /(\w+).+(:[^]+)/, R + "box-$1$2" + L + "flex-$1$2") + e;
    case 5443:
      return R + e + L + "flex-item-" + w(e, /flex-|-self/, "") + e;
    case 4675:
      return R + e + L + "flex-line-pack" + w(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return R + e + L + w(e, "shrink", "negative") + e;
    case 5292:
      return R + e + L + w(e, "basis", "preferred-size") + e;
    case 6060:
      return R + "box-" + w(e, "-grow", "") + R + e + L + w(e, "grow", "positive") + e;
    case 4554:
      return R + w(e, /([^-])(transform)/g, "$1" + R + "$2") + e;
    case 6187:
      return w(w(w(e, /(zoom-|grab)/, R + "$1"), /(image-set)/, R + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return w(e, /(image-set\([^]*)/, R + "$1$`$1");
    case 4968:
      return w(w(e, /(.+:)(flex-)?(.*)/, R + "box-pack:$3" + L + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + R + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return w(e, /(.+)-inline(.+)/, R + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (K(e) - 1 - r > 6)
        switch (Y(e, r + 1)) {
          case 109:
            if (Y(e, r + 4) !== 45)
              break;
          case 102:
            return w(e, /(.+:)(.+)-([^]+)/, "$1" + R + "$2-$3$1" + Le + (Y(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~sr(e, "stretch") ? et(w(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (Y(e, r + 1) !== 115)
        break;
    case 6444:
      switch (Y(e, K(e) - 3 - (~sr(e, "!important") && 10))) {
        case 107:
          return w(e, ":", ":" + R) + e;
        case 101:
          return w(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + R + (Y(e, 14) === 45 ? "inline-" : "") + "box$3$1" + R + "$2$3$1" + L + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (Y(e, r + 11)) {
        case 114:
          return R + e + L + w(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return R + e + L + w(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return R + e + L + w(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return R + e + L + e + e;
  }
  return e;
}
var En = function(r, n, a, o) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case vr:
        r.return = et(r.value, r.length);
        break;
      case Jr:
        return ce([be(r, {
          value: w(r.value, "@", "@" + R)
        })], o);
      case pr:
        if (r.length)
          return Jt(r.props, function(i) {
            switch (Gt(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return ce([be(r, {
                  props: [w(i, /:(read-\w+)/, ":" + Le + "$1")]
                })], o);
              case "::placeholder":
                return ce([be(r, {
                  props: [w(i, /:(plac\w+)/, ":" + R + "input-$1")]
                }), be(r, {
                  props: [w(i, /:(plac\w+)/, ":" + Le + "$1")]
                }), be(r, {
                  props: [w(i, /:(plac\w+)/, L + "input-$1")]
                })], o);
            }
            return "";
          });
    }
}, gn = [En], bn = function(r) {
  var n = r.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var a = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(a, function(b) {
      var M = b.getAttribute("data-emotion");
      M.indexOf(" ") !== -1 && (document.head.appendChild(b), b.setAttribute("data-s", ""));
    });
  }
  var o = r.stylisPlugins || gn;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var i = {}, u, l = [];
  u = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(b) {
      for (var M = b.getAttribute("data-emotion").split(" "), S = 1; S < M.length; S++)
        i[M[S]] = !0;
      l.push(b);
    }
  );
  var p, h = [ln, dn];
  process.env.NODE_ENV !== "production" && h.push(hn({
    get compat() {
      return A.compat;
    }
  }), yn);
  {
    var d, y = [nn, process.env.NODE_ENV !== "production" ? function(b) {
      b.root || (b.return ? d.insert(b.return) : b.value && b.type !== dr && d.insert(b.value + "{}"));
    } : on(function(b) {
      d.insert(b);
    })], $ = an(h.concat(o, y)), k = function(M) {
      return ce(rn(M), $);
    };
    p = function(M, S, E, P) {
      d = E, process.env.NODE_ENV !== "production" && S.map !== void 0 && (d = {
        insert: function(c) {
          E.insert(c + S.map);
        }
      }), k(M ? M + "{" + S.styles + "}" : S.styles), P && (A.inserted[S.name] = !0);
    };
  }
  var A = {
    key: n,
    sheet: new Lt({
      key: n,
      container: u,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: i,
    registered: {},
    insert: p
  };
  return A.sheet.hydrate(l), A;
}, fr = { exports: {} }, C = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Fr;
function _n() {
  if (Fr)
    return C;
  Fr = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, u = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, $ = e ? Symbol.for("react.suspense_list") : 60120, k = e ? Symbol.for("react.memo") : 60115, A = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, M = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
  function P(c) {
    if (typeof c == "object" && c !== null) {
      var V = c.$$typeof;
      switch (V) {
        case r:
          switch (c = c.type, c) {
            case p:
            case h:
            case a:
            case i:
            case o:
            case y:
              return c;
            default:
              switch (c = c && c.$$typeof, c) {
                case l:
                case d:
                case A:
                case k:
                case u:
                  return c;
                default:
                  return V;
              }
          }
        case n:
          return V;
      }
    }
  }
  function I(c) {
    return P(c) === h;
  }
  return C.AsyncMode = p, C.ConcurrentMode = h, C.ContextConsumer = l, C.ContextProvider = u, C.Element = r, C.ForwardRef = d, C.Fragment = a, C.Lazy = A, C.Memo = k, C.Portal = n, C.Profiler = i, C.StrictMode = o, C.Suspense = y, C.isAsyncMode = function(c) {
    return I(c) || P(c) === p;
  }, C.isConcurrentMode = I, C.isContextConsumer = function(c) {
    return P(c) === l;
  }, C.isContextProvider = function(c) {
    return P(c) === u;
  }, C.isElement = function(c) {
    return typeof c == "object" && c !== null && c.$$typeof === r;
  }, C.isForwardRef = function(c) {
    return P(c) === d;
  }, C.isFragment = function(c) {
    return P(c) === a;
  }, C.isLazy = function(c) {
    return P(c) === A;
  }, C.isMemo = function(c) {
    return P(c) === k;
  }, C.isPortal = function(c) {
    return P(c) === n;
  }, C.isProfiler = function(c) {
    return P(c) === i;
  }, C.isStrictMode = function(c) {
    return P(c) === o;
  }, C.isSuspense = function(c) {
    return P(c) === y;
  }, C.isValidElementType = function(c) {
    return typeof c == "string" || typeof c == "function" || c === a || c === h || c === i || c === o || c === y || c === $ || typeof c == "object" && c !== null && (c.$$typeof === A || c.$$typeof === k || c.$$typeof === u || c.$$typeof === l || c.$$typeof === d || c.$$typeof === M || c.$$typeof === S || c.$$typeof === E || c.$$typeof === b);
  }, C.typeOf = P, C;
}
var T = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var jr;
function Sn() {
  return jr || (jr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, u = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, $ = e ? Symbol.for("react.suspense_list") : 60120, k = e ? Symbol.for("react.memo") : 60115, A = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, M = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
    function P(v) {
      return typeof v == "string" || typeof v == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      v === a || v === h || v === i || v === o || v === y || v === $ || typeof v == "object" && v !== null && (v.$$typeof === A || v.$$typeof === k || v.$$typeof === u || v.$$typeof === l || v.$$typeof === d || v.$$typeof === M || v.$$typeof === S || v.$$typeof === E || v.$$typeof === b);
    }
    function I(v) {
      if (typeof v == "object" && v !== null) {
        var me = v.$$typeof;
        switch (me) {
          case r:
            var oe = v.type;
            switch (oe) {
              case p:
              case h:
              case a:
              case i:
              case o:
              case y:
                return oe;
              default:
                var te = oe && oe.$$typeof;
                switch (te) {
                  case l:
                  case d:
                  case A:
                  case k:
                  case u:
                    return te;
                  default:
                    return me;
                }
            }
          case n:
            return me;
        }
      }
    }
    var c = p, V = h, O = l, Ge = u, we = r, Je = d, Ke = a, Ce = A, G = k, X = n, re = i, Te = o, Oe = y, le = !1;
    function Pe(v) {
      return le || (le = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), de(v) || I(v) === p;
    }
    function de(v) {
      return I(v) === h;
    }
    function Ae(v) {
      return I(v) === l;
    }
    function Ne(v) {
      return I(v) === u;
    }
    function $e(v) {
      return typeof v == "object" && v !== null && v.$$typeof === r;
    }
    function He(v) {
      return I(v) === d;
    }
    function Ze(v) {
      return I(v) === a;
    }
    function pe(v) {
      return I(v) === A;
    }
    function ve(v) {
      return I(v) === k;
    }
    function ne(v) {
      return I(v) === n;
    }
    function he(v) {
      return I(v) === i;
    }
    function ae(v) {
      return I(v) === o;
    }
    function Xe(v) {
      return I(v) === y;
    }
    T.AsyncMode = c, T.ConcurrentMode = V, T.ContextConsumer = O, T.ContextProvider = Ge, T.Element = we, T.ForwardRef = Je, T.Fragment = Ke, T.Lazy = Ce, T.Memo = G, T.Portal = X, T.Profiler = re, T.StrictMode = Te, T.Suspense = Oe, T.isAsyncMode = Pe, T.isConcurrentMode = de, T.isContextConsumer = Ae, T.isContextProvider = Ne, T.isElement = $e, T.isForwardRef = He, T.isFragment = Ze, T.isLazy = pe, T.isMemo = ve, T.isPortal = ne, T.isProfiler = he, T.isStrictMode = ae, T.isSuspense = Xe, T.isValidElementType = P, T.typeOf = I;
  }()), T;
}
process.env.NODE_ENV === "production" ? fr.exports = _n() : fr.exports = Sn();
var xn = fr.exports, rt = xn, Rn = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, wn = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, tt = {};
tt[rt.ForwardRef] = Rn;
tt[rt.Memo] = wn;
var Cn = !0;
function Tn(e, r, n) {
  var a = "";
  return n.split(" ").forEach(function(o) {
    e[o] !== void 0 ? r.push(e[o] + ";") : a += o + " ";
  }), a;
}
var nt = function(r, n, a) {
  var o = r.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (a === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Cn === !1) && r.registered[o] === void 0 && (r.registered[o] = n.styles);
}, On = function(r, n, a) {
  nt(r, n, a);
  var o = r.key + "-" + n.name;
  if (r.inserted[n.name] === void 0) {
    var i = n;
    do
      r.insert(n === i ? "." + o : "", i, r.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function Pn(e) {
  for (var r = 0, n, a = 0, o = e.length; o >= 4; ++a, o -= 4)
    n = e.charCodeAt(a) & 255 | (e.charCodeAt(++a) & 255) << 8 | (e.charCodeAt(++a) & 255) << 16 | (e.charCodeAt(++a) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, r = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      r ^= (e.charCodeAt(a + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(a + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(a) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var An = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Vr = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, Nn = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", $n = /[A-Z]|^ms/g, at = /_EMO_([^_]+?)_([^]*?)_EMO_/g, mr = function(r) {
  return r.charCodeAt(1) === 45;
}, Yr = function(r) {
  return r != null && typeof r != "boolean";
}, ar = /* @__PURE__ */ sn(function(e) {
  return mr(e) ? e : e.replace($n, "-$&").toLowerCase();
}), We = function(r, n) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(at, function(a, o, i) {
          return J = {
            name: o,
            styles: i,
            next: J
          }, o;
        });
  }
  return An[r] !== 1 && !mr(r) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var kn = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, In = ["normal", "none", "initial", "inherit", "unset"], Dn = We, Mn = /^-ms-/, Fn = /-(.)/g, Lr = {};
  We = function(r, n) {
    if (r === "content" && (typeof n != "string" || In.indexOf(n) === -1 && !kn.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var a = Dn(r, n);
    return a !== "" && !mr(r) && r.indexOf("-") !== -1 && Lr[r] === void 0 && (Lr[r] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + r.replace(Mn, "ms-").replace(Fn, function(o, i) {
      return i.toUpperCase();
    }) + "?")), a;
  };
}
var ot = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function xe(e, r, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(ot);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return J = {
          name: n.name,
          styles: n.styles,
          next: J
        }, n.name;
      if (n.styles !== void 0) {
        var a = n.next;
        if (a !== void 0)
          for (; a !== void 0; )
            J = {
              name: a.name,
              styles: a.styles,
              next: J
            }, a = a.next;
        var o = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (o += n.map), o;
      }
      return jn(e, r, n);
    }
    case "function": {
      if (e !== void 0) {
        var i = J, u = n(e);
        return J = i, xe(e, r, u);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var l = [], p = n.replace(at, function(d, y, $) {
          var k = "animation" + l.length;
          return l.push("const " + k + " = keyframes`" + $.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + k + "}";
        });
        l.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(l, ["`" + p + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + p + "`"));
      }
      break;
  }
  if (r == null)
    return n;
  var h = r[n];
  return h !== void 0 ? h : n;
}
function jn(e, r, n) {
  var a = "";
  if (Array.isArray(n))
    for (var o = 0; o < n.length; o++)
      a += xe(e, r, n[o]) + ";";
  else
    for (var i in n) {
      var u = n[i];
      if (typeof u != "object")
        r != null && r[u] !== void 0 ? a += i + "{" + r[u] + "}" : Yr(u) && (a += ar(i) + ":" + We(i, u) + ";");
      else {
        if (i === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(ot);
        if (Array.isArray(u) && typeof u[0] == "string" && (r == null || r[u[0]] === void 0))
          for (var l = 0; l < u.length; l++)
            Yr(u[l]) && (a += ar(i) + ":" + We(i, u[l]) + ";");
        else {
          var p = xe(e, r, u);
          switch (i) {
            case "animation":
            case "animationName": {
              a += ar(i) + ":" + p + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && i === "undefined" && console.error(Nn), a += i + "{" + p + "}";
          }
        }
      }
    }
  return a;
}
var Wr = /label:\s*([^\s;\n{]+)\s*(;|$)/g, it;
process.env.NODE_ENV !== "production" && (it = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var J, Ur = function(r, n, a) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var o = !0, i = "";
  J = void 0;
  var u = r[0];
  u == null || u.raw === void 0 ? (o = !1, i += xe(a, n, u)) : (process.env.NODE_ENV !== "production" && u[0] === void 0 && console.error(Vr), i += u[0]);
  for (var l = 1; l < r.length; l++)
    i += xe(a, n, r[l]), o && (process.env.NODE_ENV !== "production" && u[l] === void 0 && console.error(Vr), i += u[l]);
  var p;
  process.env.NODE_ENV !== "production" && (i = i.replace(it, function($) {
    return p = $, "";
  })), Wr.lastIndex = 0;
  for (var h = "", d; (d = Wr.exec(i)) !== null; )
    h += "-" + // $FlowFixMe we know it's not null
    d[1];
  var y = Pn(i) + h;
  return process.env.NODE_ENV !== "production" ? {
    name: y,
    styles: i,
    map: p,
    next: J,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: y,
    styles: i,
    next: J
  };
}, Vn = function(r) {
  return r();
}, Yn = ee["useInsertionEffect"] ? ee["useInsertionEffect"] : !1, Ln = Yn || Vn, Be = {}.hasOwnProperty, yr = /* @__PURE__ */ ee.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ bn({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (yr.displayName = "EmotionCacheContext");
yr.Provider;
var Wn = function(r) {
  return /* @__PURE__ */ Gr(function(n, a) {
    var o = Nt(yr);
    return r(n, o, a);
  });
}, st = /* @__PURE__ */ ee.createContext({});
process.env.NODE_ENV !== "production" && (st.displayName = "EmotionThemeContext");
var zr = function(r) {
  var n = r.split(".");
  return n[n.length - 1];
}, Un = function(r) {
  var n = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(r);
  if (n || (n = /^([A-Za-z0-9$.]+)@/.exec(r), n))
    return zr(n[1]);
}, zn = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), qn = function(r) {
  return r.replace(/\$/g, "-");
}, Bn = function(r) {
  if (r)
    for (var n = r.split(`
`), a = 0; a < n.length; a++) {
      var o = Un(n[a]);
      if (o) {
        if (zn.has(o))
          break;
        if (/^[A-Z]/.test(o))
          return qn(o);
      }
    }
}, ur = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", lr = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", ct = function(r, n) {
  if (process.env.NODE_ENV !== "production" && typeof n.css == "string" && // check if there is a css declaration
  n.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + n.css + "`");
  var a = {};
  for (var o in n)
    Be.call(n, o) && (a[o] = n[o]);
  if (a[ur] = r, process.env.NODE_ENV !== "production" && n.css && (typeof n.css != "object" || typeof n.css.name != "string" || n.css.name.indexOf("-") === -1)) {
    var i = Bn(new Error().stack);
    i && (a[lr] = i);
  }
  return a;
}, Gn = function(r) {
  var n = r.cache, a = r.serialized, o = r.isStringTag;
  return nt(n, a, o), Ln(function() {
    return On(n, a, o);
  }), null;
}, ft = /* @__PURE__ */ Wn(function(e, r, n) {
  var a = e.css;
  typeof a == "string" && r.registered[a] !== void 0 && (a = r.registered[a]);
  var o = e[ur], i = [a], u = "";
  typeof e.className == "string" ? u = Tn(r.registered, i, e.className) : e.className != null && (u = e.className + " ");
  var l = Ur(i, void 0, ee.useContext(st));
  if (process.env.NODE_ENV !== "production" && l.name.indexOf("-") === -1) {
    var p = e[lr];
    p && (l = Ur([l, "label:" + p + ";"]));
  }
  u += r.key + "-" + l.name;
  var h = {};
  for (var d in e)
    Be.call(e, d) && d !== "css" && d !== ur && (process.env.NODE_ENV === "production" || d !== lr) && (h[d] = e[d]);
  return h.ref = n, h.className = u, /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement(Gn, {
    cache: r,
    serialized: l,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ ee.createElement(o, h));
});
process.env.NODE_ENV !== "production" && (ft.displayName = "EmotionCssPropInternal");
var ut = ft;
function or(e, r, n) {
  return Be.call(r, "css") ? Ye.jsx(ut, ct(e, r), n) : Ye.jsx(e, r, n);
}
function Jn(e, r, n) {
  return Be.call(r, "css") ? Ye.jsxs(ut, ct(e, r), n) : Ye.jsxs(e, r, n);
}
function Kn(e, r, n, a) {
  let o = U``;
  switch (e) {
    case "horizontal":
      o = U`
        flex-direction: row;
        justify-content: ${r};
      `;
      break;
    case "vertical":
      o = U`
        flex-direction: column;
        align-items: ${r};
      `;
      break;
  }
  let i = U``;
  return n && (typeof a == "string" ? e == "horizontal" ? i = U`
          margin-bottom: -${H(a)};
        ` : i = U`
          margin-right: -${H(a)};
        ` : (a.length == 1 && (e == "horizontal" ? i = U`
            margin-bottom: -${a[0]};
          ` : i = U`
            margin-right: -${a[0]};
          `), a.length >= 2 && (e == "horizontal" ? i = U`
            margin-bottom: -${a[1]};
          ` : i = U`
            margin-right: -${a[0]};
          `))), U`
    display: inline-flex;
    vertical-align: middle;
    flex-wrap: ${n ? "wrap" : "nowrap"};
    ${i};
    ${o};
  `;
}
function Me(e, r, n, a) {
  let o, i;
  switch (r) {
    case "horizontal":
      o = r == "horizontal" && !a ? H(e) : "0px", i = n ? H(e) : "0px";
      break;
    case "vertical":
      i = r == "vertical" && !a ? H(e) : "0px", o = n ? H(e) : "0px";
      break;
  }
  return U`
    display: inline-flex;
    margin-right: ${o};
    margin-bottom: ${i};
  `;
}
function Hn(e, r, n) {
  let a, o;
  switch (r) {
    case "horizontal":
      a = r == "horizontal" && !n ? H(e[0]) : "0px", o = H(e[1]);
      break;
    case "vertical":
      o = r == "vertical" && !n ? H(e[1]) : "0px", a = H(e[0]);
      break;
  }
  return U`
    display: inline-flex;
    margin-right: ${a};
    margin-bottom: ${o};
  `;
}
function qr(e, r, n, a) {
  if (typeof e == "string")
    return Me(e, r, n, a);
  if (e.length == 1)
    return Me(e[0], r, n, a);
  if (e.length >= 2) {
    if (n)
      return Hn(e, r, a);
    switch (r) {
      case "horizontal":
        return Me(e[0], r, n, a);
      case "vertical":
        return Me(e[1], r, n, a);
    }
  } else
    return U``;
}
function H(e) {
  switch (e) {
    case "mini":
      return "4px";
    case "small":
      return "8px";
    case "medium":
      return "16px";
    case "large":
      return "24px";
    default:
      return e;
  }
}
const Zn = Gr((e, r) => {
  const { size: n = "small", align: a = "start", direction: o = "horizontal", divider: i, wrap: u, ...l } = e;
  let p = $t.toArray(e.children);
  return or("div", { css: [
    Kn(o, a, u ?? !1, n),
    Dt(e)
  ], ref: r, ...Mt(l), children: p.map((h, d) => Jn(kt, { children: [d != 0 && i ? or(It, { css: qr(n, o, u ?? !1, !1), direction: o == "horizontal" ? "vertical" : "horizontal" }) : null, or("div", { css: qr(n, o, u ?? !1, d == p.length - 1), children: h })] }, (h == null ? void 0 : h.key) || d)) });
});
Zn.displayName = "Space";
export {
  Zn as Space
};
//# sourceMappingURL=index.js.map
